import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const InviteMembersComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "InviteMembersPage" */ "@circle-react/components/SettingsApp/ManageMembers/InviteModal"
    ),
);

export const InviteMembersPage = () => (
  <Suspense fallback={<PageLoader />}>
    <InviteMembersComponent />
  </Suspense>
);
